import React from 'react';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { useAuthContext } from '../context/Auth/AuthContext';
import ElEmbudo from '../pages/ElEmbudo/ElEmbudo';
import Home from '../pages/Home/Home';
import Login from '../pages/Login/Login';
import PegaMas from '../pages/PegaMas/PegaMas';
import ProtectedRoutes from './protectedRoutes';

const AppRoutes: React.FC = () => {
  const { isAuthenticated } = useAuthContext();
  
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/login" element={isAuthenticated ? <Navigate to="/" replace /> : <Login />} />
        <Route path="/" element={<ProtectedRoutes><Home /></ProtectedRoutes>} />
        <Route path="/el-embudo" element={<ProtectedRoutes><ElEmbudo /></ProtectedRoutes>} />
        <Route path="/pegamas" element={<ProtectedRoutes><PegaMas/></ProtectedRoutes>} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;